import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetRest from './CharacterSheetRest.vue';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
import CharacterSheetHealthCircle from './CharacterSheetHealthCircle.vue';
import CheckList from '@/components/CheckList.vue';
let CharacterSheetHealth = class CharacterSheetHealth extends Vue {
    constructor() {
        super(...arguments);
        this.healthMod = 0;
    }
    addHitPoints() {
        const hitPoints = Math.min(this.hitPoints.maximum, this.hitPoints.current + this.healthMod);
        const hitPointsLost = Math.max(0, this.hitPoints.maximum - hitPoints);
        this.$emit('updateCharacter', { currentStats: { hitPointsLost, deathSaves: { successes: 0, failures: 0 } } });
        this.healthMod = 0;
    }
    subtractHitPoints() {
        const temporaryHitPoints = Math.max(0, this.hitPoints.temporary - this.healthMod);
        const resultingHP = this.hitPoints.current + this.hitPoints.temporary - this.healthMod;
        const hitPoints = temporaryHitPoints > 0 ? this.hitPoints.current : Math.max(0, resultingHP);
        const failures = (resultingHP * -1 >= this.hitPoints.maximum) ? 3 : this.hitPoints.deathSaves.failures;
        const hitPointsLost = Math.max(0, this.hitPoints.maximum - hitPoints);
        this.$emit('updateCharacter', { currentStats: { hitPointsLost, temporaryHitPoints, deathSaves: { failures } } });
        this.healthMod = 0;
    }
    addTHP() {
        if (this.healthMod > this.hitPoints.temporary) {
            this.$emit('updateCharacter', { currentStats: { temporaryHitPoints: this.healthMod } });
        }
        this.healthMod = 0;
    }
    updateDeathSaves(saveType, newValue) {
        this.$emit('updateCharacter', { currentStats: { deathSaves: { [saveType]: newValue } } });
    }
};
__decorate([
    Prop(Object)
], CharacterSheetHealth.prototype, "hitPoints", void 0);
__decorate([
    Prop(Object)
], CharacterSheetHealth.prototype, "tweaks", void 0);
CharacterSheetHealth = __decorate([
    Component({
        components: {
            CharacterSheetTweaker,
            CharacterSheetRest,
            CharacterSheetHealthCircle,
            CheckList
        }
    })
], CharacterSheetHealth);
export default CharacterSheetHealth;
